module.exports = __webpack_public_path__ + "assets/img/e16a-py.svg";